export const formatDatetime = (datetime: string, siteTimeZone?: string): string => {
    return `${datetime.substring(0, 10)} ${datetime.substring(11, 16)} ${siteTimeZone ? '(' + siteTimeZone + ')' : ''}`;
};
